import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './CounterTopSOW.module.scss';
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../../actions/wizard";

const CounterTopSOW = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Function to update the specific options item.
  const assignOptionValue = (value, id, keyName) => {
    const optionObject = updatedValues?.metaData?.[id];
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [id]: {
          ...optionObject,
          [keyName]: value
        }
      }
    };

    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
    
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {  
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  const scopeOfWorkConstants = [
    {
      id: 'existing_countertop_removal',
      label: 'Existing Countertop Removal',
      options: ['Not required', 'Homelane', 'Cx']
    },
    {
      id: 'countertop_material_supply',
      label: 'Countertop Material Supply',
    },
    {
      id: 'countertop_installation',
      label: 'Countertop Installation',
    },
    {
      id: 'sink_cutting',
      label: 'Sink Cutting',
      options: ['No', 'Yes']
    },
    {
      id: 'hob_cutting',
      label: 'Hob Cutting',
      options: ['No', 'Yes']
    },
    {
      id: 'gas_puncture_hole',
      label: 'Gas Puncture Hole',
      options: ['No', 'Yes']
    },
    {
      id: 'tap_hole',
      label: 'Tap Hole',
      options: ['No', 'Yes']
    }
  ];

  return (
    <section className={style.scope_work_container}>
      <h1 className="section_heading">Countertop Scope of Work Table</h1>
      <div className={style.sow_table_section}>
        <div className={style.four_col_tab_heading}>
          <p>Service</p>
          <p>Scope</p>
          <p>Quantity</p>
        </div>
        {
          scopeOfWorkConstants?.map((e: any, i: any) => (
            <div className={style.four_col_tab_body} key={i}>
              <p>{e?.label}</p>
              <p>
                {
                  !isDrawingsExporting
                    ?
                    e?.options?.length ? <select className={style.edit_select_options} onChange={(v) => assignOptionValue(v.target.value, e?.id, 'scope')}>
                      {
                        e?.options?.map((o: any) => <option value={o} selected={updatedValues?.metaData?.[e.id]?.['scope'] == o}>{o}</option>)
                      }
                    </select>
                      :
                      <input value={updatedValues?.metaData?.[e.id]?.['scope'] || updatedValues?.counterTopMaterialSow?.[e.id]?.['scope'] || ''} onChange={(v) => assignOptionValue(v.target.value, e?.id, 'scope')} />
                    : updatedValues?.metaData?.[e.id]?.['scope'] || updatedValues?.counterTopMaterialSow?.[e.id]?.['scope'] || e?.options?.[0] || ''}
              </p>
              <p>{!isDrawingsExporting ? <input value={updatedValues?.metaData?.[e.id]?.['quantity'] || updatedValues?.counterTopMaterialSow?.[e.id]?.['quantity'] || ''} onChange={(v) => assignOptionValue(v.target.value, e?.id, 'quantity')} /> : updatedValues?.metaData?.[e.id]?.['quantity'] || updatedValues?.counterTopMaterialSow?.[e.id]?.['quantity'] || ''} </p>
            </div>
          ))
        }
      </div>
    </section>
  )
}

export default CounterTopSOW